import {createListFromObject, getTextByValue} from "../../../Utilities/Types/listUtilities";

export const LOAN_LIBRARY_CATEGORY = {
    Technology: 0,
    Braille: 1,
    PsychologicalAssessments: 2,
    ComprehensiveAssessments: 3,
    ProfessionalMaterials: 4,
    InstructionalMaterials: 5,
    EiFamilyResources: 6,
    MD: 7,
};

export const LOAN_LIBRARY_MEDIA_FORMAT = {
    DVD: 1,
    CD: 2,
    TeacherResource: 3,
    StudentMaterials: 4,
    UEB: 5,
    UEBNemeth: 6,
    USBDrive: 7,
    EPub: 8,
    Link: 9,
    Technology: 10,
    HardCopy: 11,
    Tangible: 12,
};

export const LOAN_LIBRARY_MEDIA_FORMAT_LIST = createListFromObject(LOAN_LIBRARY_MEDIA_FORMAT);

export const getLoanLibraryMediaFormatTextByValue = (value: string | number = "") => getTextByValue(LOAN_LIBRARY_MEDIA_FORMAT_LIST, value);

export const INVENTORY_STATUS = {
    Available: 1,
    CheckedOut: 2,
    Reserved: 3,
    Damaged: 4,
    Lost: 5,
    InRepair: 6,
    Retired: 7,
};

export const INVENTORY_STATUS_LIST = createListFromObject(INVENTORY_STATUS);

export const getInventoryStatusTextByValue = (value: string | number = "") => getTextByValue(INVENTORY_STATUS_LIST, value);

export const LOAN_DURATION = {
    ThirtyDays : 30,
    SixtyDays : 60,
    NinetyDays : 90,
    SchoolYear : 180
};

export const LOAN_DURATION_LIST = createListFromObject(LOAN_DURATION);

export const getLoanDurationTextByValue = (value: string | number = "") => getTextByValue(LOAN_DURATION_LIST, value);
